export const MIN_FILE_SIZE = 1;
export const MAX_FILE_SIZE = 10485760;
export const FILE_MIME_TYPES_DEFAULT = 'application/pdf';
export const FILE_MIME_TYPES_INVOICE = 'application/pdf,application/xml,text/xml';
